import React, { useEffect, useState } from 'react'
import Main from '../../cpn/Main'
import { Flex, Form, Input, Radio, Space, Table, Select } from 'antd';
import { useYonghuListQuery } from '../../store/DianShangYeWuApi';
import UserEdit from './UserEdit';
import UserAdd from './UserAdd';
import Icon from '../../cpn/Icon';
import classes from '../system.module.css';
function UserList() {
    const [list, setList] = useState();    
    const qy_id = JSON.parse(localStorage.getItem('jtg-caiwu_qy_id'))
    const qy_name = JSON.parse(localStorage.getItem('jtg-caiwu_qy_name'))
    const yh_id = JSON.parse(localStorage.getItem('jtg-caiwu_yh_id'))
    const yh_name = JSON.parse(localStorage.getItem('jtg-caiwu_yh_name'))
    const [query,setQuery] = useState({
        yh_qy_id:qy_id,
        yh_name:'',
        yh_phone:'',
        yh_state:'',
        yh_qx:'',
    })
    const {data, isSuccess} = useYonghuListQuery(query,{refetchOnMountOrArgChange:true});

    useEffect(() => {
        if (isSuccess) {
            // console.log(data);
            if(data.Status==='success'){                
                const newArr = data.Result.map(item => {
                    const {yh_id:key,yh_name,yh_phone,yh_qx,yh_state,yh_juese,yh_uname,yh_ctime,yh_update_time,yh_update_uname} = item;                 
                    return item = {key,yh_name,yh_phone,yh_qx,yh_state,yh_juese,yh_uname,yh_ctime,yh_update_time,yh_update_uname}
                }) 
                const sortArr = newArr.sort( (a, b) => {      
                    let aTimeString = a.yh_ctime;
                    let bTimeString = b.yh_ctime;
                    let aTime = new Date(aTimeString).getTime();
                    let bTime = new Date(bTimeString).getTime();
                    return bTime - aTime;     
                    },)
                setList(sortArr)
            }else{
                setList('')
            }
            
        }
    }, [data, isSuccess])
    const columns = [
        {
            key: 'yh_name',
            title: '姓名',            
            dataIndex: 'yh_name',
            render:(text,record) => {
                return <UserEdit 
                            user_id={record.key}
                            user_name={text} 
                            yh_id={yh_id} 
                            yh_name={yh_name} 
                            qy_name={qy_name} 
                            qy_id={qy_id}
                            yh_ctime={record.yh_ctime}
                            yh_update_time={record.yh_update_time}
                            yh_uname={record.yh_uname}
                            yh_update_uname={record.yh_update_uname}
                        />
            }
        },      
        {
            key: 'yh_phone',
            title: '登录手机号码',            
            dataIndex: 'yh_phone',
        },     
        {
            key: 'yh_qx',
            title: '权限',            
            dataIndex: 'yh_qx',
        },      
        {
            key: 'yh_state',
            title: '状态',            
            dataIndex: 'yh_state',
            render:(text) => {
                if(text==='1'){
                    return <span style={{color:'green'}}>启用</span>
                }else{
                    return <span style={{color:'red'}}>禁用</span>
                }
            }
        },                   
        {
            key: 'key',
            title: '编号',
            dataIndex: 'key',
        },
    ]   
    const [form] = Form.useForm();
    return (
        <Main selectedKeys={['/UserList']}>                        
            <Flex align='center' justify='space-between'>
               
                <Form
                    layout='inline'
                    form={form}
                    onFinish={(values) => {   
                        console.log(values);
                        setQuery({...query,yh_name:values.yh_name,yh_phone:values.yh_phone,yh_state:values.yh_state,yh_qx:values.yh_qx})
                    }}
                    initialValues={{
                        yh_name:'',
                        yh_phone:'',
                        yh_state:'',
                        yh_qx:undefined,
                    }}
                >
                    <Form.Item name='yh_name'>
                        <Input placeholder='请输入姓名' />
                    </Form.Item>
                    <Form.Item name='yh_phone'>
                        <Input placeholder='请输入手机号码' />
                    </Form.Item>
                    <Form.Item name='yh_qx'>
                        <Select placeholder='请选择权限' allowClear style={{width:'150px'}}>
                            <Select.Option value={'业务'}>业务</Select.Option>
                            <Select.Option value={'管理'}>管理</Select.Option>
                        </Select>
                    </Form.Item>
                    <Form.Item name='yh_state'>
                        <Radio.Group>
                            <Radio value={'1'}>启用</Radio>
                            <Radio value={'2'}>禁用</Radio>
                        </Radio.Group>
                    </Form.Item>
                    <Form.Item>
                        <Space align='center' size='middle'>
                            <Icon type='search' onClick={() => {form.submit()}}/>
                            <Icon type='reset'  onClick={() => {
                                form.resetFields();
                                setQuery({...query,yh_name:'',yh_phone:'',yh_state:'',yh_juese:''})
                            }}/>                            
                            
                        </Space>
                    </Form.Item>
                </Form>
                <UserAdd qy_id={qy_id} qy_name={qy_name} yh_id={yh_id} yh_name={yh_name} />
            </Flex>
            <Table 
                columns={columns} 
                dataSource={list} 
                pagination={{
                    showSizeChanger:true,
                    defaultPageSize:'50',
                    showTotal:(total) => `共${total}条`,
                }} 
                className={classes.customTable}
                style={{marginTop:"10px"}}
                rowKey="key"
            />
        </Main>
    )
}

export default UserList